import { render } from "./RecentVideosSection.vue?vue&type=template&id=6919a482&ts=true"
import script from "./RecentVideosSection.vue?vue&type=script&lang=ts"
export * from "./RecentVideosSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__